import Icon from "@mui/material/Icon";
const routes = [
  {
    name: "Dashboard",
    icon: <Icon>dashboard</Icon>,
    route: "/admin/dashboard",
  },
  {
    name: "Test",
    icon: <Icon>dashboard</Icon>,
    route: "/admin/test",
  },
];

export default routes;
